import { UserDetails, UserLevelReportResponse } from '@/models/mygooru-reports/mygooru-reports';
import { appConfigService } from '@/providers/services/app/app-config';
import { DEFAULT_REPORT_IMAGES_PATH } from '@/utils/constants';
import { formatDuration } from '@/utils/utils';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'user-report-card',
})
export default class UserReportCard extends Vue {

    @Prop()
    public userLevelReport!: UserLevelReportResponse;

    @Prop()
    public reportType!: string;

    public searchQuery: string = '';

    public selectedUserIds: string[] = [];

    public report: UserDetails[] = [];


    public get reportUserType() {
        return appConfigService.getReportUserType();
    }

    public get filteredUsers() {
        // Return all users if the search query is empty.
        if (!this.searchQuery) { return this.report; }
        const query = this.searchQuery.toLowerCase();
        return this.report.filter((user: any) =>
            ((user.first_name || '').toLowerCase().includes(query)) ||
            ((user.last_name || '').toLowerCase().includes(query)) ||
            ((user.email || '').toLowerCase().includes(query)) ||
            ((user.username || '').toLowerCase().includes(query)),
        );
    }

    @Watch('userLevelReport', { deep: true })
    public async onChangeData() {
        this.normalizeReportData();
    }

    // --------------------------------------------------------------
    // Hooks

    public async created() {
        this.report = [];
        this.normalizeReportData();
    }

    public normalizeReportData() {
        this.report = this.userLevelReport.reports.map((user: any) => {
            const spentTime = user.total_session_time_seconds || user.total_time_spent_seconds;
            return {
                ...user,
                profile: this.getThumbnailUrl(user),
                color: this.reportUserType[user.user_type].line,
                activeColor: this.reportUserType[user.user_type].activeColor || '#000',
                userName: user.first_name
                    ? `${user.first_name}${user.last_name ? ` ${user.last_name}` : ''}`
                    : user.username || user.email || user.display_name || '',
                timeSpend: spentTime > 0 ? formatDuration(spentTime) : 0,
            };
        });
    }

    public onSelectUser(userId: string) {
        const index = this.selectedUserIds.indexOf(userId);
        if (index > -1) {
            this.selectedUserIds.splice(index, 1);
        } else {
            this.selectedUserIds.push(userId);
        }
        // Emit the updated selectedUserId array
        this.$emit('onSelectUsers', this.selectedUserIds, this.reportType);
    }

    public onClose() {
        this.selectedUserIds = [];
        this.$emit('onClose', this.reportType, this.selectedUserIds);
    }

    public getThumbnailUrl(res: any): string {
        return res.thumbnail
            ? res.cdn_urls.user_cdn_url + res.thumbnail
            : window.location.origin +
            DEFAULT_REPORT_IMAGES_PATH[Math.floor(Math.random() * DEFAULT_REPORT_IMAGES_PATH.length)];
    }

    public onLoadMore(event: Event) {
        const target = event.target as HTMLElement;
        const isScrolledToBottom = Math.ceil(target.scrollTop + target.offsetHeight) >= target.scrollHeight;
        const hasMoreReports = this.userLevelReport.totalCount > this.report.length;

        if (isScrolledToBottom && hasMoreReports) {
            this.$emit('onLoadMore', this.reportType, this.selectedUserIds);
        }
    }
}
